export const NexusRoutes = {
  Account: (id: string) => `${NexusRoutes.Accounts}${id}/`,
  AccountHoldings: (id: string) => `${NexusRoutes.Accounts}${id}/holdings/`,
  Accounts: '/investors/investment_accounts/',
  AccountTransactions: (id: string) => `/investors/investment_accounts/${id}/transactions/`,
  AccountDocuments: (id: string) => `/investors/investment_accounts/${id}/documents/`,
  GromaCoinOverview: '/gromacoin/overview/',
  WalletBalance: (id: string) => `/investors/wallets/${id}/balance/`,
};
